module.exports = __webpack_public_path__ + "static/logo.motusvfx-5c88b786cf4d21f24168b0139b658cb4.png";